import Reveal from "@/components/Reveal";
import { MapPin, Building2, Users } from "lucide-react";

const OFFICES = [
  {
    tag: "Sede legale",
    city: "Milano",
    address: "Via Pordenone 13, 20132 Milano (MI)",
    desc: "Relazioni istituzionali, segreteria e coordinamento nazionale. Sportello: lunedì - venerdì 9:00 - 13:00; altri orari su appuntamento specifico.",
    icon: Building2,
    image:
      "https://images.unsplash.com/photo-1660156528705-0f9d05f8d064?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxtaWxhbiUyMGFyY2hpdGVjdHVyZSUyMG1vZGVybiUyMGl0YWx5JTIwc3RyZWV0fGVufDB8fHx8MTc4ODY5MzcwMnww&ixlib=rb-4.1.0&q=85",
    alt: "Architettura di Milano, dove ha sede legale l'associazione",
  },
  {
    tag: "Sede operativa",
    city: "Gallarate (VA)",
    address: "Via Scipione Ronchetti 8, 21013 Gallarate (VA)",
    desc: "Sportello di ascolto, consulenza gratuita e percorsi di supporto psicologico.",
    icon: Users,
    image:
      "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxoYW5kcyUyMGhvbGRpbmclMjBzdXBwb3J0JTIwY29tcGFzc2lvbiUyMHdhcm10aHxlbnwwfHx8fDE3ODg2OTM3MDJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Volontari della comunità che si sostengono a vicenda",
  },
];

export default function Sedi() {
  return (
    <section id="sedi" data-testid="sedi-section" className="container-site py-20 lg:py-28">
      <Reveal className="max-w-2xl">
        <span className="eyebrow">Dove trovarci</span>
        <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-ink">
          Due sedi, una porta sempre aperta.
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
        {OFFICES.map((o, i) => (
          <Reveal key={o.city} delay={i * 0.12}>
            <article className="group rounded-3xl overflow-hidden border border-slate-100 bg-white shadow-sm hover:shadow-xl hover:shadow-brand-blue/8 transition-shadow duration-300" data-testid={`office-card-${i}`}>
              <div className="overflow-hidden h-56">
                <img
                  src={o.image}
                  alt={o.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-7">
                <span className="inline-flex items-center gap-2 rounded-full bg-brand-mist text-brand-blue text-xs font-bold uppercase tracking-wider px-3 py-1.5">
                  <o.icon className="w-3.5 h-3.5" />
                  {o.tag}
                </span>
                <h3 className="mt-4 text-2xl font-extrabold text-brand-ink">{o.city}</h3>
                <p className="mt-2 flex items-center gap-2 font-semibold text-brand-blue">
                  <MapPin className="w-4 h-4" />
                  {o.address}
                </p>
                <p className="mt-3 text-slate-600 leading-relaxed">{o.desc}</p>
                <a
                  href={`/prenota?sede=${o.tag === "Sede legale" ? "Milano" : "Gallarate"}`}
                  className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-blue text-white font-bold px-6 h-12 transition-transform duration-200 hover:-translate-y-0.5"
                  data-testid={`office-prenota-link-${i}`}
                >
                  Prenota un colloquio gratuito
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
